import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function authHeaders() {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");
  return { Authorization: `Bearer ${token}` };
}

export const getSkillAgentMoodboardsMeta = async () => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-moodboards/meta`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const listSkillAgentMoodboards = async (params = {}) => {
  const response = await axios.get(`${API_URL}/api/skill-agent-moodboards`, {
    headers: authHeaders(),
    params,
  });
  return response.data;
};

export const getSkillAgentMoodboardById = async (id) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-moodboards/${id}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const createSkillAgentMoodboard = async (payload) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-moodboards`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const updateSkillAgentMoodboard = async (id, payload) => {
  const response = await axios.patch(
    `${API_URL}/api/skill-agent-moodboards/${id}`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const deleteSkillAgentMoodboard = async (id) => {
  const response = await axios.delete(
    `${API_URL}/api/skill-agent-moodboards/${id}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const getSkillAgentMoodboardPool = async (id) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-moodboards/${id}/pool`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const getSkillAgentMoodboardMeetingPool = async (id) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-moodboards/${id}/meeting-pool`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const addSkillAgentMoodboardAssets = async (
  id,
  { searchItemIds = [], meetingPhotoIds = [], files = [], sessionId } = {},
) => {
  const form = new FormData();
  if (searchItemIds.length) {
    form.append("searchItemIds", JSON.stringify(searchItemIds));
  }
  if (meetingPhotoIds.length) {
    form.append("meetingPhotoIds", JSON.stringify(meetingPhotoIds));
  }
  if (sessionId) {
    form.append("sessionId", String(sessionId));
  }
  for (const f of files) {
    form.append("files", f);
  }
  const response = await axios.post(
    `${API_URL}/api/skill-agent-moodboards/${id}/assets`,
    form,
    {
      headers: {
        ...authHeaders(),
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const deleteSkillAgentMoodboardAsset = async (id, assetId) => {
  const response = await axios.delete(
    `${API_URL}/api/skill-agent-moodboards/${id}/assets/${assetId}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const removeBgSkillAgentMoodboardAsset = async (id, assetId) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-moodboards/${id}/assets/${assetId}/remove-bg`,
    { replaceInPages: true },
    { headers: authHeaders(), timeout: 130000 },
  );
  return response.data;
};

export const contourStrokeSkillAgentMoodboardAsset = async (
  id,
  assetId,
  { width = 6, color = "#000000" } = {},
) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-moodboards/${id}/assets/${assetId}/contour-stroke`,
    { width, color, replaceInPages: true },
    { headers: authHeaders(), timeout: 60000 },
  );
  return response.data;
};

export const cropSkillAgentMoodboardAsset = async (
  id,
  assetId,
  { x, y, w, h },
) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-moodboards/${id}/assets/${assetId}/crop`,
    { x, y, w, h, replaceInPages: true },
    { headers: authHeaders(), timeout: 60000 },
  );
  return response.data;
};

export const saveSkillAgentMoodboardPages = async (
  id,
  pages,
  { expectedUpdatedAt } = {},
) => {
  const response = await axios.patch(
    `${API_URL}/api/skill-agent-moodboards/${id}/pages`,
    {
      PagesJson: pages,
      ...(expectedUpdatedAt ? { ExpectedUpdatedAt: expectedUpdatedAt } : {}),
    },
    { headers: authHeaders() },
  );
  return response.data;
};

export const autoSkillAgentMoodboardPages = async (id) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-moodboards/${id}/pages/auto`,
    {},
    { headers: authHeaders() },
  );
  return response.data;
};

export const exportSkillAgentMoodboardPdf = async (id, body = {}) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-moodboards/${id}/export-pdf`,
    body,
    { headers: authHeaders(), timeout: 180000 },
  );
  return response.data;
};

export const createSkillAgentMoodboardFromMeeting = async (payload) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-moodboards/from-meeting`,
    payload,
    { headers: authHeaders(), timeout: 180000 },
  );
  return response.data;
};

export const fetchSkillAgentMoodboardAssetBlobUrl = async (assetId) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-moodboards/assets/${assetId}/file`,
    { headers: authHeaders(), responseType: "blob" },
  );
  return URL.createObjectURL(response.data);
};
